<template>
  <DragPanel
    :title="getTitle()"
    :closePanel="closePanel"
    :tooltipVisible="false"
  >
    <div class="dataset-content-box">
      <div class="special-schemeType-tip-box">
        <div v-if="schemeType === 'Rs'" class="dialog-tip">
          <span class="tips-text">
            注：仅显示与当前场景坐标系一致的遥感影像
          </span>
        </div>
        <div v-if="schemeType === 'Wmts'" class="dialog-tip">
          <span class="tips-text">
            注：仅显示与当前场景坐标系一致的wmts服务
          </span>
        </div>
        <div v-if="schemeType === 'Cad'" class="dialog-tip">
          <span class="tips-text">
            注：仅显示设置过坐标系的二维图纸
          </span>
        </div>
      </div>
      <div class="tabs-box" v-if="schemeType === 'Bim'">
        <div
          :class="`tab-item-box dialog-label ${isActiveTab('model') ? 'active' : ''}`"
          @click="setActiveTab('model')"
        >
          模型
        </div>
        <div
          :class="`tab-item-box dialog-label ${isActiveTab('modelGroup') ? 'active' : ''}`"
          @click="setActiveTab('modelGroup')"
        >
          模型组
        </div>
      </div>
      <DataSetCardList
        ref="dataSetCard"
        v-if="dataShowMode === 'card'"
        :schemeType="schemeType"
        :currDataSetFolder="currDataSetFolder"
        :isModelGroup="isModelGroup"
        :switchDataViewMode="switchDataViewMode"
        :updateScene="updateScene"
        :updateSceneVector="updateSceneVector"
        :updateStatisticInfo="updateStatisticInfo"
      />
      <DataSetTree
        ref="dataSetTree"
        v-if="dataShowMode === 'tree'"
        :schemeType="schemeType"
        :currDataSetFolder="currDataSetFolder"
        :isModelGroup="isModelGroup"
        :switchDataViewMode="switchDataViewMode"
        :updateScene="updateScene"
        :updateSceneVector="updateSceneVector"
        :updateStatisticInfo="updateStatisticInfo"
      />
      <div class="tip-box">
        <span class="dialog-label">目标路径：</span>
        <div
          class="path-name-box muti-line-text-overflow dialog-label"
          :title="formatCurrNodeName()"
        >
          {{ formatCurrNodeName() }}
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <div class="statistic-info-box public-tips-primary">
        {{ statisticInfo }}
      </div>
      <div class="common-button-box" v-if="dataShowMode === 'tree'">
        <el-button class="primary-btn primary-ang-btn" type="primary" size="mini" @click="addToScene">
          确定
        </el-button>
      </div>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from "@/components/CustomDragPanel.vue";
import DataSetCardList from "./DataSetCardList.vue";
import DataSetTree from "./DataSetTree.vue";
const DataSetType = [
  {
    value: "Bim",
    label: "模型",
  },
  {
    value: "Rs",
    label: "遥感影像",
  },
  {
    value: "Wmts",
    label: "wmts",
  },
  {
    value: "Osgb",
    label: "倾斜摄影",
  },
  {
    value: "PointCloud",
    label: "点云",
  },
  {
    value: "Cad",
    label: "二维图纸",
  },
  {
    value: "Vector",
    label: "矢量",
  },
];
export default {
  data() {
    return {
      activeTab: "model",
      isModelGroup: false,
      dataShowMode: "card",

      statisticInfo: "",
    };
  },
  props: {
    schemeType: String,
    currDataSetFolder: Object,
    updateScene: Function,
    updateSceneVector: Function,
    closeDataSetPanel: Function,
  },
  components: {
    DragPanel,
    DataSetCardList,
    DataSetTree,
  },
  watch: {
    schemeType: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dataShowMode = "card";
        this.$nextTick(() => {
          this.initData();
        });
      }
    },
  },
  methods: {
    initData() {
      let dataShowMode = this.dataShowMode;
      let domRef = null;
      if (dataShowMode === "card") {
        domRef = this.$refs.dataSetCard;
      } else {
        domRef = this.$refs.dataSetTree;
      }
      domRef.initData();
    },
    updateData() {
      let dataShowMode = this.dataShowMode;
      let domRef = null;
      if (dataShowMode === "card") {
        domRef = this.$refs.dataSetCard;
      } else {
        domRef = this.$refs.dataSetTree;
      }
      domRef.updateData();
    },
    switchDataViewMode() {
      let dataShowMode = this.dataShowMode;
      if (dataShowMode === "card") {
        this.dataShowMode = "tree";
      } else {
        this.dataShowMode = "card";
      }
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      let isModelGroup = tab === "modelGroup" ? true : false;
      this.isModelGroup = isModelGroup;
      this.initData();
    },
    isActiveTab(tab) {
      return this.activeTab === tab;
    },
    getTitle() {
      let find = DataSetType.find((el) => el.value === this.schemeType);
      return find.label;
    },
    addToScene() {
      let domRef = this.$refs.dataSetTree;
      domRef.addToScene();
    },
    formatCurrNodeName() {
      let levelPathName = "";

      if (Object.keys(this.currDataSetFolder).length) {
        levelPathName = this.currDataSetFolder.levelPathName;
      } else {
        levelPathName = `${this.getTitle()}根目录`;
      }

      return levelPathName;
    },
    updateStatisticInfo(statisticInfo) {
      this.statisticInfo = statisticInfo;
    },
    closePanel() {
      this.closeDataSetPanel();
    },
    // 打开其他面板前的校验
    openOtherPanelCheck() {
      return new Promise((resolve) => {
        this.closeDataSetPanel();
        resolve(true);
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.common-drag-panel {
  left: 6px;
  top: 6px;
  width: 360px;
  height: 640px;
  min-width: 360px;
  min-height: 640px;

  /deep/ .content {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);

    .dataset-content-box {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      padding: 8px 15px;
      font-size: 14px;
      height: calc(100% - 64px);
      background-color: var(--base-bg-dark-color45);
      

      .special-schemeType-tip-box {
        text-align: left;
        color: #cccccc;

        .dialog-tip{
          padding-top: 5px;
          background-color: transparent;
          margin-bottom: 6px;
        }
      }

      .tabs-box {
        display: flex;
        border-radius: 4px;
        background: var(--attr-tabs-bgColor);
        margin-bottom: 8px;

        .tab-item-box {
          margin: 2px;
          flex-grow: 1;
          padding: 5px;
          border-radius: 3px;
          cursor: pointer;
          color: var(--tabs-item-text-color);
        }

        .active {
          color: var(--aside-bg-color);
          background: var(--base-primary-color);
        }
      }

      .tip-box {
        display: flex;
        align-items: center;
        padding-top: 15px;

        .path-name-box {
          text-align: left;
        }
      }
    }

    .bottom-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 64px;
      text-align: left;
      margin: auto 0px;
      padding: 0px 15px;
      border-top: 1px solid var(--dialog-split-line-color);

      .statistic-info-box {
        font-size: 12px;
        color: var(--scene-dialog-tips);
      }

      .common-button-box {
        .el-button {
          border-radius: 4px;
          margin-right: 0px;
        }
      }
    }
  }
}
</style>